import React, { useState } from "react";

const compounds = [
  { name: "Comp1", top: 27.75, left: 8.25, width: 8, height: 14 },
  { name: "Comp2", top: 38.5, left: 10.25, width: 8.25, height: 7.25 },
  { name: "Comp3", top: 45.52, left: 12, width: 9.25, height: 6.25 },
  { name: "Comp4", top: 53, left: 11.25, width: 11.25, height: 7.25 },
  { name: "Comp5", top: 59.55, left: 12.55, width: 12.25, height: 5.25 },
  { name: "Comp6", top: 65.35, left: 13.55, width: 12.25, height: 6.25 },
  { name: "Comp7", top: 72.05, left: 15.05, width: 12.25, height: 6.25 },
  { name: "Comp8", top: 78.45, left: 16.55, width: 11.25, height: 5.75 },
  { name: "Comp9", top: 84.85, left: 17.55, width: 11.25, height: 5.75 },
  { name: "Comp10", top: 92.85, left: 18.95, width: 11.25, height: 7.75 },

  { name: "Comp11", top: 21.95, left: 18, width: 10.25, height: 6.25 },
  { name: "Comp12", top: 27.86, left: 19, width: 10.25, height: 5.25 },
  { name: "Comp13", top: 35.1, left: 20.5, width: 9.25, height: 6.25 },
  { name: "Comp14", top: 41.05, left: 22.05, width: 9.25, height: 5.57 },
  { name: "Comp15", top: 51.05, left: 21.85, width: 6.25, height: 8.58 },
  { name: "Comp16", top: 59.45, left: 23.25, width: 6.25, height: 8.0 },
  { name: "Comp17", top: 69.05, left: 25.85, width: 6.25, height: 8.55 },
  { name: "Comp18", top: 76.95, left: 28.15, width: 6.25, height: 7.0 },
  { name: "Comp19", top: 86.05, left: 30.05, width: 8.15, height: 7.0 },
  { name: "Comp20", top: 92.75, left: 31.45, width: 8.15, height: 5.57 },

  { name: "Comp21", top: 84.55, left: 37.85, width: 6.75, height: 7.55 },
  { name: "Comp22", top: 83.58, left: 46.05, width: 7.25, height: 8.25 },
  { name: "Comp23", top: 81.55, left: 52.85, width: 6.25, height: 7.25 },
  { name: "Comp24", top: 88.85, left: 53.15, width: 5.25, height: 6.65 },
  { name: "Comp25", top: 80.45, left: 62.35, width: 8.85, height: 8.18 },
  { name: "Comp26", top: 79.45, left: 71.85, width: 10.25, height: 9.05 },
  { name: "Comp27", top: 77.25, left: 79.55, width: 5.25, height: 9.45 },
  { name: "Comp28", top: 67.75, left: 81.05, width: 10.65, height: 5.45 },
  { name: "Comp29", top: 62.65, left: 79.55, width: 10.65, height: 5.05 },
  { name: "Comp30", top: 56.85, left: 78.85, width: 11.65, height: 6.05 },

  { name: "Comp31", top: 50.55, left: 78.05, width: 12.65, height: 6.45 },
  { name: "Comp32", top: 45.25, left: 77.05, width: 12.65, height: 4.25 },
  { name: "Comp33", top: 40.65, left: 75.85, width: 12.95, height: 4.45 },
  { name: "Comp34", top: 36.75, left: 73.21, width: 8.95, height: 3.45 },
  { name: "Comp35", top: 32.25, left: 77.05, width: 9.65, height: 6.45 },
  { name: "Comp36", top: 32.25, left: 67.85, width: 8.65, height: 5.45 },
  { name: "Comp37", top: 34.95, left: 59.15, width: 9.85, height: 6.25 },
  { name: "Comp38", top: 28.91, left: 57.75, width: 9.85, height: 4.85 },
  { name: "Comp39", top: 23.85, left: 56.45, width: 8.45, height: 4.85 },
  { name: "Comp40", top: 19.1, left: 54.75, width: 7.85, height: 4.25 },

  { name: "Comp41", top: 21.5, left: 45.15, width: 8.75, height: 5.25 },
  { name: "Comp42", top: 23.8, left: 36.75, width: 8.55, height: 5.25 },
  { name: "Comp43", top: 25.55, left: 28.15, width: 9.0, height: 5.25 },
  { name: "Comp44", top: 33.55, left: 29.45, width: 8.45, height: 6.25 },
  { name: "Comp45", top: 31.95, left: 37.75, width: 8.05, height: 7.25 },
  { name: "Comp46", top: 29.75, left: 46.25, width: 9.05, height: 7.25 },
  { name: "Comp47", top: 36.71, left: 46.75, width: 8.85, height: 6.25 },
  { name: "Comp48", top: 38.4, left: 38.25, width: 7.85, height: 5.55 },
  { name: "Comp49", top: 39.9, left: 30.55, width: 7.85, height: 5.25 },
  { name: "Comp50", top: 50.0, left: 27.75, width: 5.25, height: 9.25 },

  { name: "Comp51", top: 48.82, left: 32.85, width: 5.25, height: 9.25 },
  { name: "Comp52", top: 48.15, left: 38.15, width: 5.25, height: 9.25 },
  { name: "Comp53", top: 47.05, left: 43.05, width: 5.25, height: 9.25 },
  { name: "Comp54", top: 46.05, left: 48.45, width: 5.25, height: 9 },
  { name: "Comp55", top: 45.55, left: 53.55, width: 5.25, height: 9 },
  { name: "Comp56", top: 46.75, left: 59.45, width: 4.25, height: 10 },
  { name: "Comp57", top: 43.75, left: 64.45, width: 5.25, height: 8 },
  { name: "Comp58", top: 51.85, left: 65.95, width: 5.25, height: 8.45 },
  { name: "Comp59", top: 53.45, left: 55.15, width: 5.25, height: 7 },
  { name: "Comp60", top: 54.22, left: 50.05, width: 4.95, height: 7.15 },

  { name: "Comp61", top: 55.05, left: 44.75, width: 5.25, height: 7.25 },
  { name: "Comp62", top: 56.25, left: 39.45, width: 5.25, height: 7.25 },
  { name: "Comp63", top: 57.22, left: 34.05, width: 5.25, height: 8.45 },
  { name: "Comp64", top: 58.55, left: 29.15, width: 5.25, height: 8.05 },
  { name: "Comp65", top: 68.05, left: 32.45, width: 6.25, height: 8.05 },
  { name: "Comp66", top: 67.22, left: 38.55, width: 5.05, height: 8.45 },
  { name: "Comp67", top: 66.05, left: 43.75, width: 5.25, height: 8.85 },
  { name: "Comp68", top: 64.05, left: 51.45, width: 7.25, height: 8.25 },
  { name: "Comp69", top: 62.95, left: 58.12, width: 6.25, height: 8.45 },
  { name: "Comp70", top: 62.15, left: 63.75, width: 5.25, height: 8.85 },

  { name: "Comp71", top: 60.55, left: 68.85, width: 5.25, height: 8.0 },
  { name: "Comp72", top: 68.45, left: 70.95, width: 5.25, height: 8.45 },
  { name: "Comp73", top: 70.05, left: 65.75, width: 5.25, height: 8.05 },
  { name: "Comp74", top: 70.95, left: 59.75, width: 6.25, height: 8.18 },
  { name: "Comp75", top: 72.12, left: 53.25, width: 6.25, height: 8.25 },
  { name: "Comp76", top: 74.75, left: 43.75, width: 9.25, height: 6.55 },
  { name: "Comp77", top: 76.05, left: 35.05, width: 5.75, height: 8.12 },
];

const InteractiveMap = () => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const allRecordimage = "upload/images/compentionlayout.png";
  const [selectedComp, setSelectedComp] = useState(null);
  const handleClick = (name) => {
    console.log("Clicked:", name);
    setSelectedComp(name);
    
  };

  return (
    <div>
      <style>
        {`
                    .map-container {
                        position: relative;
                        display: flex;
                        justify-content: center;
                        width: 100%;
                    }
                    .map-image {
                        width: 100%;
                        height: auto;
                    }
                    .compound {
                        position: absolute;
                        background-color: rgba(255, 0, 0, 0.3);
                        cursor: pointer;
                        transform: translate(-50%, -50%);
                    }
                `}
      </style>
      <div className="map-container">
        <img
          src={BACKEND_URL + allRecordimage}
          alt="Map"
          className="map-image"
        />
        {compounds.map((comp) => (
          <div
            key={comp.name}
            className="compound"
            style={{
              top: `${comp.top}%`,
              left: `${comp.left}%`,
              width: `${comp.width}%`,
              height: `${comp.height}%`,
            }}
            onClick={() => handleClick(comp.name)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default InteractiveMap;
